import { Chip } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChipFilteredData } from '../../utils';
import * as S from './Chips.styles';

export interface ChipsProps {
  chipData: ChipFilteredData[];
  isFocused: boolean;
  activeChip?: string;
  handleChangeChip: (selectedChip: string) => void;
}

export const Chips = ({
  chipData,
  activeChip,
  isFocused,
  handleChangeChip,
}: ChipsProps) => {
  const { t } = useTranslation('chart');

  return (
    <S.ChipsContainer data-testid="chips-wrapper">
      {chipData.map(chip => (
        <Chip
          key={chip.name}
          isActive={chip.value === activeChip}
          isFocused={chip.value === activeChip && isFocused}
          /* i18next-extract-disable-next-line */
          label={t(chip.name)}
          onClick={() => handleChangeChip(chip.value)}
          variation="outline"
          data-testid={`chip-${chip.value}`}
        />
      ))}
    </S.ChipsContainer>
  );
};
